import React, { useCallback, useState } from 'react';

import Menu from '@mui/material/Menu';

import { Box } from '@vk-hr-tek/ui/Box';
import { Button } from '@vk-hr-tek/ui/Button';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Counter } from '@vk-hr-tek/ui/Counter';

import { useDispatch, useSelector } from '@app/hooks';

import {
  selectBellNotificationsStatus,
  selectBellNotificationsWithDateGroups,
  getBellNotifications,
  selectBellCounter,
} from '../../../slice';

const MAX_BELL_NOTIFICATIONS = 99;

import { useStyles } from './Bell.styles';
import { Header } from './Header';
import { Body } from './Body';
import { Footer } from './Footer';

export const Bell = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectBellNotificationsStatus);
  const items = useSelector(selectBellNotificationsWithDateGroups);
  const counter = useSelector(selectBellCounter);

  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
      dispatch(getBellNotifications({ isRead: false, limit: 15 }));
    },
    [dispatch],
  );

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const isMenuOpen = Boolean(anchorEl);
  const menuId = 'bell-notification-menu';

  return (
    <Box display="flex" alignItems="center">
      <Box display="inline" position="relative" onClick={handleMenuOpen}>
        {!!counter && (
          <Box
            position="absolute"
            left={21}
            top={2}
            zIndex={1}
            cursor="pointer"
          >
            <Counter
              backgroundColor="red"
              color="white"
              counter={counter > MAX_BELL_NOTIFICATIONS ? '99+' : counter}
              size="extraSmall"
            />
          </Box>
        )}
        <Button
          variant="tertiaryLight"
          onClick={handleMenuOpen}
          icon={
            <Icon
              name={
                counter
                  ? 'notification_subtract_outline'
                  : 'notification_outline'
              }
              size="24"
              color="original.brand.primary"
            />
          }
        />
      </Box>

      {isMenuOpen && (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 40,
            horizontal: 'right',
          }}
          id={menuId}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          classes={{ list: classes.menu }}
          open={isMenuOpen}
          onClose={handleMenuClose}
        >
          <Box display="flex" flexDirection="column">
            <Header />
            <Body onClose={handleMenuClose} />
            {(items.length > 0 || status === 'loading') && (
              <Footer onClose={handleMenuClose} />
            )}
          </Box>
        </Menu>
      )}
    </Box>
  );
};
